import { BrowserRouter, Routes, Route } from 'react-router-dom';
import About from './components/About/About';
import Error from './components/Error/Error';
import Home from './components/Home/Home';
import Projekte from './components/Projekte/Projects';
import Veranstaltungen from './components/Veranstaltungen/Veranstaltungen';
import AgriConnect from './components/AgriConnect/AgriConnect';
import Presse from './components/Presse/Presse';
import SharedLayout from './components/SharedLayout/SharedLayout';
import Impressum from './components/Impressum/Impressum';
import Datenschutz from './components/Datenschutz/Datenschutz';
import Signin from './components/Signin/Signin';
import UserArea from './components/UserArea/UserArea';
import ProjectForm from './components/UserArea/ProjectForm/ProjectForm';
import EventForm from './components/UserArea/EventForm/EventForm';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import { AuthContextProvider } from './context/AuthContext';
import './App.css';

function App() {
  return (
    <AuthContextProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SharedLayout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="projekte" element={<Projekte />} />
            <Route path="veranstaltungen" element={<Veranstaltungen />} />
            <Route path="agri-connect" element={<AgriConnect />} />
            <Route path="presse" element={<Presse />} />
            <Route path="impressum" element={<Impressum />} />
            <Route path="datenschutz" element={<Datenschutz />} />
            <Route path="signin" element={<Signin />} />
            <Route path="userarea" element={<ProtectedRoute><UserArea /></ProtectedRoute>} />
            <Route path="userarea/projekte/neu" element={<ProtectedRoute><ProjectForm /></ProtectedRoute>} />
            <Route path="userarea/projekte/:id/bearbeiten" element={<ProtectedRoute><ProjectForm /></ProtectedRoute>} />
            <Route path="userarea/veranstaltungen/neu" element={<ProtectedRoute><EventForm /></ProtectedRoute>} />
            <Route path="userarea/veranstaltungen/:id/bearbeiten" element={<ProtectedRoute><EventForm /></ProtectedRoute>} />
            <Route path="*" element={<Error />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthContextProvider>
  );
}

export default App;
